import { useCallback, useState } from 'react';

// 与 useState 用法相同，但值会持久化到 localStorage
export function useLocalStorageState(key, defaultValue) {
  const [value, setValue] = useState(() => {
    try {
      const raw = localStorage.getItem(key);
      return raw !== null ? JSON.parse(raw) : defaultValue;
    } catch {
      return defaultValue;
    }
  });

  const set = useCallback(
    (v) => {
      setValue((prev) => {
        const next = typeof v === 'function' ? v(prev) : v;
        try {
          localStorage.setItem(key, JSON.stringify(next));
        } catch {
          // 隐私模式等场景下写入失败，仅保留内存状态
        }
        return next;
      });
    },
    [key]
  );

  return [value, set];
}
